export const FIND_OPEN_PROCESS_STATEMENTS_FAILURE = 'FIND_OPEN_PROCESS_STATEMENTS_FAILURE';

export const findOpenProcessStatementsFailure = ({ error, request }) => ({
    type: FIND_OPEN_PROCESS_STATEMENTS_FAILURE,
    payload: error,
    error: true,
    meta: {
        request
    }
});